module.exports = __webpack_public_path__ + "media/toolkits/block-1-image-8a50eec9.png";